<script setup lang="ts">
const { data: events, suspense } = useEvents()

await suspense()

const relevantEvents = computed(() => {
  const today = new Date()
  const lastRelevantDate = addMonths(today, 5)
  return events.value
    ?.filter((event) => {
      const start = new Date(event.dates[0] ?? today)
      const end = new Date(event.dates[event.dates.length - 1] ?? today)
      return (
        (start > today || end > today) &&
        (start < lastRelevantDate || end < lastRelevantDate) &&
        event.highlighted === true
      )
    })
    .sort(byFirstDate('asc'))
    .slice(0, 3)
})
</script>

<template>
  <section v-if="relevantEvents?.length" class="relative min-h-32 w-full bg-beige-10 pb-16 text-green-50">
    <UContainer>
      <h2 class="mt-12 pl-4 text-xl tracking-[0.2rem] uppercase md:mt-22 md:mb-8 md:text-3xl">
        Arrangementer
      </h2>
      <div class="my-12 flex w-full flex-wrap gap-4 md:mt-8 md:mb-16">
        <CardsEventSimple
          v-for="event in relevantEvents"
          :key="event.id"
          :event="event"
        />
      </div>
      <NuxtLink class="group mt-8 flex items-center gap-8 no-underline hover:underline md:-mt-8" :to="{ name: 'events' }">
        <UIcon name="fal:arrow-right-long" class="ml-5 transition-transform group-hover:translate-x-3 md:scale-[2]" />
        <span class="text-lg font-medium transition-transform group-hover:translate-x-3 sm:text-xl">Se alle arrangementer</span>
      </NuxtLink>
    </UContainer>
    <StaticAsset
      folder="graphics"
      file="cream_wave_corner.svg"
      class="absolute right-0 bottom-0 hidden md:block"
      aria-hidden="true"
    />
  </section>
</template>
